const React = require("react");

function DotsCircleHorizontalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 12h.01M12 12h.01M16 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

module.exports = DotsCircleHorizontalIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/DotsCircleHorizontalIcon.js
 ** module id = 514
 ** module chunks = 0
 **/